export default __webpack_public_path__ + "static/media/10@3x.78714171.png";